(() => {
  const bound = new WeakSet();
  const all = (root, selector) => [...root.querySelectorAll(selector)];
  const scrollBehavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  function buyBox(root) {
    if (bound.has(root)) return;
    bound.add(root);
    const data = JSON.parse(root.querySelector('[data-buybox-data]').textContent);
    const form = root.querySelector('[data-buy-form]');
    const cards = all(root, '.iw-choice');
    const buttons = all(root, '[data-buy-button]');
    const onceButtons = all(root, '[data-buy-once]');
    const modes = all(root, '[name="purchase-type"]');
    const error = root.querySelector('[data-form-error]');
    const renewal = root.querySelector('[data-renewal]');
    const params = new URLSearchParams(location.search);
    const currency = new Intl.NumberFormat(data.locale || 'en-US', { style: 'currency', currency: data.currency || 'USD' });
    const money = n => currency.format(n / 100);
    const variants = new Map(data.variants.map(v => [String(v.id), v]));
    const hasPlans = data.variants.some(v => v.plans.length);
    let mode = params.has('variant') ? (params.has('selling_plan') ? 'subscription' : 'once') : data.defaultMode;
    if (data.requiresPlan) mode = 'subscription';
    else if (!hasPlans) mode = 'once';
    let selected = params.get('variant') || cards[data.defaultOffer - 1]?.dataset.variantId;
    let busy = false;
    function planFor(v) { return v?.plans.find(p => String(p.id) === params.get('selling_plan')) || v?.plans[0]; }
    function valid(card) {
      const v = variants.get(card.dataset.variantId);
      return v?.available && (mode === 'once' || !!planFor(v));
    }
    const percent = (price, base) => base > 0 ? Math.max(0, Math.round((1 - price / base) * 100)) : 0;
    function update() {
      if (!cards.some(c => c.dataset.variantId === selected && valid(c))) selected = cards.find(valid)?.dataset.variantId;
      modes.forEach(input => {
        input.checked = input.value === mode;
        if (input.value === 'subscription') input.closest('label').hidden = !hasPlans;
      });
      cards.forEach(card => {
        const v = variants.get(card.dataset.variantId);
        const p = mode === 'subscription' ? planFor(v) : null;
        const input = card.querySelector('input');
        const isSelected = card.dataset.variantId === selected;
        input.disabled = !valid(card);
        input.checked = isSelected;
        card.classList.toggle('selected', isSelected);
        const price = p?.price ?? v?.price ?? 0;
        const compare = p ? v.price : v?.compare || 0;
        card.querySelector('.iw-choice-price strong').textContent = v ? money(price) : data.labels.soldOut;
        const del = card.querySelector('del');
        del.textContent = money(compare); del.hidden = compare <= price;
        const discount = p ? percent(p.price, v.price) : 0;
        const banner = card.querySelector('.iw-choice-banner');
        banner.textContent = [discount ? `${discount}% ${data.labels.discount}` : '', card.dataset.badge].filter(Boolean).join(' · ');
        banner.hidden = !banner.textContent;
        const recurringDiscount = p ? percent(p.recurring, v.price) : 0;
        card.querySelector('[data-recurring]').textContent = p && recurringDiscount ? `${recurringDiscount}% ${data.labels.recurring}` : '';
      });
      const v = variants.get(selected);
      const p = mode === 'subscription' ? planFor(v) : null;
      form.elements.id.value = v?.id || '';
      form.elements.selling_plan.disabled = !p;
      form.elements.selling_plan.value = p?.id || '';
      if (renewal) renewal.textContent = !v ? '' : p ? `${data.labels.first} ${money(p.price)}. ${data.labels.then} ${money(p.recurring)} ${data.labels.every} ${p.interval || p.name}. ${data.labels.cancel}` : data.labels.onceTerms;
      buttons.forEach(button => {
        button.disabled = busy || !v || !v.available || (mode === 'subscription' && !p);
        button.querySelector('b').textContent = busy ? data.labels.busy : v ? button.dataset.label : data.labels.soldOut;
      });
      onceButtons.forEach(button => { button.disabled = busy || !v; button.querySelector('span').textContent = v ? money(v.price) : ''; });
    }
    form.addEventListener('change', event => {
      if (event.target.name === 'purchase-type') mode = event.target.value;
      if (event.target.name === 'tea-supply') selected = event.target.value;
      error.hidden = true; update();
    });
    async function submit() {
      const v = variants.get(selected); const p = mode === 'subscription' ? planFor(v) : null;
      if (busy || !v?.available || (mode === 'subscription' && !p)) return;
      if (window.Shopify?.designMode) { error.textContent = 'Preview only. Open the storefront to test checkout.'; error.hidden = false; return; }
      busy = true; error.hidden = true; update();
      try {
        const item = { id: v.id, quantity: 1 };
        if (p) item.selling_plan = p.id;
        const prefix = data.root?.endsWith('/') ? data.root : `${data.root || ''}/`;
        const response = await fetch(`${prefix}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || data.labels.error);
        location.assign(data.destination === 'cart' ? `${prefix}cart` : `${prefix}checkout`);
      } catch (e) { error.textContent = e.message || data.labels.error; error.hidden = false; busy = false; update(); }
    }
    form.addEventListener('submit', event => { event.preventDefault(); submit(); });
    onceButtons.forEach(button => button.addEventListener('click', () => { mode = 'once'; update(); submit(); }));
    const thumbs = all(root, '.iw-thumb');
    const featured = root.querySelector('.iw-featured');
    let imageIndex = 0;
    function showImage(i) {
      if (!thumbs.length || !featured) return;
      imageIndex = (i + thumbs.length) % thumbs.length;
      featured.removeAttribute('srcset'); featured.src = thumbs[imageIndex].dataset.image; featured.alt = thumbs[imageIndex].dataset.alt || '';
      thumbs.forEach((button, index) => { button.classList.toggle('active', index === imageIndex); button.setAttribute('aria-pressed', String(index === imageIndex)); });
    }
    thumbs.forEach((button, i) => button.addEventListener('click', () => showImage(i)));
    all(root, '[data-gallery-step]').forEach(button => { button.disabled = thumbs.length < 2; button.addEventListener('click', () => showImage(imageIndex + Number(button.dataset.galleryStep))); });
    root.addEventListener('shopify:block:select', event => { const i = thumbs.findIndex(t => t === event.target || t.contains(event.target)); if (i >= 0) showImage(i); });
    update();
  }
  function reviews(root) {
    if (bound.has(root)) return;
    bound.add(root);
    const list = root.querySelector('[data-review-list]');
    const cards = all(list, '.iw-review');
    const sort = root.querySelector('[data-review-sort]');
    const nav = root.querySelector('[data-review-pagination]');
    const status = root.querySelector('[data-review-status]');
    const pageSize = Number(root.dataset.pageSize) || 5;
    let page = 0;
    let sorted = [...cards];
    function render() {
      cards.forEach(card => { card.hidden = true; });
      sorted.slice(page * pageSize, (page + 1) * pageSize).forEach(card => { card.hidden = false; list.append(card); });
      status.textContent = cards.length ? `Showing ${page * pageSize + 1}–${Math.min((page + 1) * pageSize, cards.length)} of ${cards.length} reviews` : 'No reviews yet';
      nav.replaceChildren();
      for (let i = 0; i < Math.ceil(cards.length / pageSize); i++) {
        const b = document.createElement('button'); b.type = 'button'; b.textContent = i + 1; b.setAttribute('aria-label', `Review page ${i + 1}`);
        if (page === i) b.setAttribute('aria-current', 'page');
        b.addEventListener('click', () => { page = i; render(); root.querySelector('.iw-reviews-toolbar').scrollIntoView({ behavior: scrollBehavior(), block: 'start' }); });
        nav.append(b);
      }
    }
    function reorder() {
      sorted = [...cards].sort((a,b) => sort.value === 'highest' ? Number(b.dataset.rating) - Number(a.dataset.rating) : sort.value === 'lowest' ? Number(a.dataset.rating) - Number(b.dataset.rating) : b.dataset.date.localeCompare(a.dataset.date));
      page = 0; render();
    }
    sort.addEventListener('change', reorder);
    root.addEventListener('shopify:block:select', event => { const card = event.target.closest('.iw-review'); if (card) { page = Math.floor(sorted.indexOf(card) / pageSize); render(); card.scrollIntoView({ block: 'center' }); } });
    reorder();
  }
  function carousel(track) {
    if (bound.has(track)) return;
    bound.add(track);
    const root = track.closest('[data-replo-carousel]');
    const slides = [...track.children];
    if (!root || !slides.length) return;
    const dots = all(root, '[aria-label^="Go to slide"]');
    let active = 0, frame = 0;
    const position = slide => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const update = () => {
      frame = 0;
      active = slides.reduce((nearest, slide, index) => Math.abs(position(slide) - track.scrollLeft) < Math.abs(position(slides[nearest]) - track.scrollLeft) ? index : nearest, 0);
      slides.forEach((slide, index) => slide.setAttribute('data-is-active', String(index === active)));
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
    };
    const go = index => { active = (index + slides.length) % slides.length; track.scrollTo({ left: position(slides[active]), behavior: scrollBehavior() }); };
    all(root, '[data-replo-part="nav-button"]').forEach(button => button.addEventListener('click', () => go(active + (button.dataset.direction === 'previous' ? -1 : 1))));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    root.addEventListener('keydown', e => { if (!['ArrowLeft','ArrowRight'].includes(e.key)) return; e.preventDefault(); go(active + (e.key === 'ArrowLeft' ? -1 : 1)); });
    update();
  }
  function init(root) {
    all(root, '[data-iw-buybox]').forEach(buyBox);
    all(root, '[data-iw-reviews]').forEach(reviews);
    all(root, '.iw-scroll-track').forEach(carousel);
    all(root, '.iw-editable-header').forEach(header => {
      if (bound.has(header)) return;
      bound.add(header);
      const toggle = header.querySelector('#iw-menu-toggle'), menu = header.querySelector('#iw-menu');
      toggle?.addEventListener('click', () => { menu.classList.toggle('open'); toggle.setAttribute('aria-expanded', String(menu.classList.contains('open'))); });
      all(header, 'nav a').forEach(a => a.addEventListener('click', () => { menu.classList.remove('open'); toggle?.setAttribute('aria-expanded','false'); }));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
